import { Grid, makeStyles, TextField } from '@material-ui/core';
import Button from 'components/Button';
import { FormikErrors } from 'formik';
import i18n from 'i18n';
import { getAllCompaniesRequest } from 'modules/companies/actions';
import { modalClose, modalOpen } from 'modules/modal/actions';
import { ModalFields } from 'modules/modal/interfaces';
import React from 'react';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import { get } from 'lodash';
import CompanyList from './companyList';
import styles from './styles';

const useStyles = makeStyles(styles);

export interface CompanyFieldsProps {
  company_name?: string;
  company_uuid?: string;
}

interface SelectCompanyProps {
  closeOnSelect?: boolean;
  companyFields: CompanyFieldsProps | null;
  disabled?: boolean;
  errors?: FormikErrors<any>;
  stateKey: string;
  modalClose: () => void;
  modalOpen: (props: ModalFields) => void;
  setCompanyFields: (prop: CompanyFieldsProps | null) => void;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void;
}

const SelectCompany = ({
  closeOnSelect,
  companyFields,
  disabled,
  errors,
  stateKey,
  modalClose,
  modalOpen,
  setCompanyFields,
  setFieldValue,
}: SelectCompanyProps) => {
  const classes = useStyles();

  return (
    <TextField
      className={classes.selectCompanyField}
      fullWidth
      id="btn-select-company"
      label={i18n.t('COMPANY_KEY')}
      placeholder={i18n.t('CHOOSE_COMPANY_KEY')}
      value={companyFields?.company_name || ''}
      disabled={disabled}
      variant="outlined"
      InputProps={{ readOnly: true }}
      InputLabelProps={{ shrink: true }}
      error={!!get(errors, stateKey)}
      helperText={get(errors, stateKey)}
      onClick={() =>
        modalOpen({
          title: i18n.t('CHOOSE_COMPANY_KEY'),
          content: (
            <CompanyList
              closeOnSelect={closeOnSelect}
              companyFields={companyFields}
              stateKey={stateKey}
              setCompanyFields={setCompanyFields}
              setFieldValue={setFieldValue}
            />
          ),
          maxWidth: 'md',
          fullWidth: true,
          footer: (
            <Grid>
              <Button
                id="cancel-button"
                variant="outlined"
                onClick={modalClose}
              >
                {i18n.t('CANCEL_KEY')}
              </Button>
            </Grid>
          ),
        })
      }
    />
  );
};

const mapStateToProps = ({
  companies: { companyList, isLoading },
}: ApplicationState) => ({
  companyList,
  isLoading,
});

export default connect(mapStateToProps, {
  getAllCompaniesRequest,
  modalClose,
  modalOpen,
})(SelectCompany);
